module.exports = __webpack_public_path__ + "static/media/bunny.34c0c45f.jpg";